const p = {
  class: {
    canCreateNew: true,
    canEditExisting: true,
  },
  course: {
    canCreateNew: true,
    canEditCourseInfo: true,
    actOnDotsbuttonTile: true,
  },
  chapter: {
    canCreateNew: true,
    canEditInfo: true,
    canSortChapter: true,
    canDeleteChapter: true,
    canArchiveChapter: true,
    canHideChapter: true,
    canCloneChapter: true,
    canDuplicateChapter: true,
    canBulkAssign: true,
    bulkAssignOptions: [
      {
        value: 'review',
        label: 'Submit for SE Correction',
      },
      {
        value: 'qc_review',
        label: 'Submitted for QC review',
        // isDisabled: true,
      },
      {
        value: 'teacher_review',
        label: 'Submit for Tutor Vetting',
      },
    ],
  },
  mindmap: {
    dropDownOptions: [
      {
        value: 'review',
        label: 'Submit for SE Correction',
      },
      {
        value: 'qc_review',
        label: 'Submit back to QC review',
      },
      {
        value: 'teacher_review',
        label: "Submitted for Teacher's review",
      },
      {
        value: 'teacher_verified',
        label: 'Mark as verified',
      },
    ],
  },
  lesson: {
    canAddLesson: true,
    canEditLesson: true,
    canSortLesson: true,
    canArchiveLesson: true,
    canHideLesson: true,
    canCloneLesson: true,
    canDuplicateLesson: true,
  },
  subLesson: {
    canAddSubLesson: true,
    canEditSubLesson: true,
    canSortSubLesson: true,
    canArchiveSubLesson: true,
    canHideSubLesson: true,
    canCloneSubLesson: true,
    canDuplicateSubLesson: true,
  },
  topic: {
    notes: {
      canPublish: false,
      canAddComments: true,
      canViewComments: true,
      showDraft: false,
      reviewOptions: [
        {
          value: 'review',
          label: 'Submit for SE Correction',
        },
        {
          value: 'qc_review',
          label: 'Submit back to QC review',
        },
        {
          value: 'teacher_review',
          label: "Submitted for Teacher's review",
        },
        {
          value: 'teacher_verified',
          label: 'Mark as verified',
        },
        // {
        //   value: 'inactive',
        //   label: 'Draft',
        // },
      ],
    },
    geekCorner: {
      canPublish: false,
      canAddComments: true,
      canViewComments: true,
      showDraft: false,
      reviewOptions: [
        {
          value: 'review',
          label: 'Submit for SE Correction',
        },
        {
          value: 'qc_review',
          label: 'Submit back to QC review',
        },
        {
          value: 'teacher_review',
          label: "Submitted for Teacher's review",
        },
        {
          value: 'teacher_verified',
          label: 'Mark as verified',
        },
      ],
    },
  },
  perform: {
    quiz: {
      reviewOptions: [
        // {
        //   value: 'draft',
        //   label: 'Draft',
        // },
        {
          value: 'review',
          label: 'Submit for SE Correction',
        },
        {
          value: 'qc_review',
          label: 'Submitted for QC review',
          isDisabled: true,
        },
        {
          value: 'teacher_review',
          label: 'Submit for Tutor Vetting',
        },
      ],
    },
  },
};

export default p;
